var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 300,
    viewBox: "0 0 389 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.455 238.75C387.455 271.796 360.546 298.704 327.501 298.704H1.2959V61.2496C1.2959 28.2043 28.2043 1.2959 61.2496 1.2959H387.455V238.75V238.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.237 177.853H306.021C306.729 177.853 308.382 177.617 309.09 177.617C313.811 176.672 317.823 172.424 317.823 166.523C317.823 160.858 313.811 156.609 309.09 155.429C308.382 155.193 306.966 155.193 306.021 155.193H281.237V177.853Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.189 21.3591C279.585 21.3591 260.23 40.4782 260.23 64.3181V108.929H320.892C322.308 108.929 323.961 108.929 325.141 109.165C338.831 109.874 348.981 116.955 348.981 129.229C348.981 138.906 342.135 147.168 329.389 148.82V149.292C343.316 150.236 353.937 158.025 353.937 170.063C353.937 183.045 342.135 191.543 326.557 191.543H259.994V278.877H323.016C346.62 278.877 365.975 259.758 365.975 235.918V21.3591H303.189V21.3591Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.755 132.061C314.755 126.396 310.742 122.619 306.021 121.911C305.549 121.911 304.369 121.675 303.661 121.675H281.237V142.447H303.661C304.369 142.447 305.785 142.447 306.021 142.211C310.742 141.503 314.755 137.726 314.755 132.061V132.061Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7341 21.3591C42.1303 21.3591 22.7751 40.4782 22.7751 64.3181V170.299C34.8131 176.2 47.3231 179.977 59.8331 179.977C74.7035 179.977 82.7289 171.007 82.7289 158.733V108.693H119.551V158.497C119.551 177.853 107.513 193.667 66.6782 193.667C41.8942 193.667 22.5391 188.238 22.5391 188.238V278.641H85.5613C109.165 278.641 128.52 259.522 128.52 235.682V21.3591H65.7341V21.3591Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.462 21.3591C160.858 21.3591 141.503 40.4782 141.503 64.3181V120.495C152.361 111.29 171.244 105.389 201.693 106.805C217.979 107.513 235.446 111.998 235.446 111.998V130.173C226.713 125.688 216.327 121.675 202.873 120.731C179.741 119.079 165.815 130.409 165.815 150.236C165.815 170.299 179.741 181.629 202.873 179.741C216.327 178.797 226.713 174.548 235.446 170.299V188.474C235.446 188.474 218.215 192.959 201.693 193.667C171.244 195.083 152.361 189.182 141.503 179.977V279.113H204.525C228.129 279.113 247.484 259.994 247.484 236.154V21.3591H184.462V21.3591Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 260.19,
    y1: 166.551,
    x2: 366.26,
    y2: 166.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 260.188,
    y1: 150.015,
    x2: 366.265,
    y2: 150.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 260.188,
    y1: 132.031,
    x2: 366.261,
    y2: 132.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 22.7251,
    y1: 150.015,
    x2: 130.437,
    y2: 150.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 140.893,
    y1: 150.015,
    x2: 245.505,
    y2: 150.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.37c5e9d0.svg";
export { ForwardRef as ReactComponent };